import { useCallback } from "react";
import { useAppDispatch } from "../store/hooks/useAppDispatch";
import { getReportConfiguration } from "../store/thunks/currentReportThunks";
import type { ReportConfiguration } from "../../../../../api/types/svTypes.ts";

const useCurrentReportConfiguration = () => {
  const dispatch = useAppDispatch();

  const getCurrentReportConfigurationAsync = useCallback(async (): Promise<ReportConfiguration | undefined> => {
    const result = await dispatch(getReportConfiguration()).unwrap();
    return result;
  }, [dispatch]);

  return { getCurrentReportConfigurationAsync };
};

export default useCurrentReportConfiguration;
